const reloadPage = () => {
  globalThis.location.reload();
};

export { reloadPage };
